// Using bitwise operator I can
// pass back multiple codes.
export enum OffenseCodes {
  ok = 0,
}



// WEBPACK FOOTER //
// ./src/models/offenseCodes.ts